import { isDevelopmentEnvironment } from "shared/utils/checkEnvironment";
import { twMerge } from "tailwind-merge";

interface ContainerProps {
  children: any;
  className?: string;
}
const Container = ({ children, className = "" }: ContainerProps) => {
  return (
    <div
      className={twMerge(
        isDevelopmentEnvironment() ? "gg-container gg-mx-auto" : "",
        "2xl:gg-max-w-screen-1.9xl",
        className
      )}
    >
      {children}
    </div>
  );
};
export default Container;
